import './vendor/modernizr';
import { AnimateObserver } from './lib/animate-observer';
import { Accordion } from './lib/accordion';
import collapse from '@alpinejs/collapse';

import { Carousel } from './lib/carousel';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Alpine from 'alpinejs';
import { FeedSelector } from './lib/feed-selector';
import { Categories } from './lib/categories';
import { Turnstile } from './lib/turnstile';
window.Accordion = Accordion;
window.FeedSelector = FeedSelector;
window.Categories = Categories;
window.Alpine = Alpine

Alpine.plugin(collapse)
Alpine.start()

const animate = new AnimateObserver();
animate.init();

const carousel = new Carousel();
carousel.init();

const turnstile = new Turnstile();
turnstile.init();

if ( document.querySelector( '.js-auto-animate' ) ) {
    import('./lib/auto-animate').then( module => {
        const autoAnimate = new module.AutoAnimate();
        autoAnimate.init();
    } );
}

if ( document.querySelector( '.js-scroller' ) ) {
    import('./lib/scroller').then( module => {
        const scroll = new module.Scroller();
        scroll.init();
    } );
}

if ( document.querySelector( '.js-map' ) ) {
    // import module for side effects
    import('google-maps-api-loader').then( module => {

        const loader = module.default( {
            version: 'weekly',
            libraries: [],
            apiKey: process.env.GMAPS_API_KEY,
        } ).then( ( google ) => {

            if ( document.querySelector( '.js-map' ) ) {
                import('./lib/map').then( module => {
                    const maps = new module.Maps( google );

                    maps.init();
                } );
            }
        } );
    } );
}

Fancybox.bind("[data-fancybox]", {});
